import { Flex, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '~/components/core'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { Size } from '~/types/ThemeTypes'

import type { ExtensionSelectResult } from '@mangovoice/mango-api-client'
import { Checkbox } from '@mangovoice/mango-ui'

interface MoveVoicemailModalProps {
  isOpen: boolean
  onClose: () => void
  voicemailBoxes: ExtensionSelectResult[]
  currentExtensionId: number
  onMove: (extensionId: number, markAsUnread: boolean) => void
}

export const MoveVoicemailModal = ({
  isOpen,
  onClose,
  voicemailBoxes,
  currentExtensionId,
  onMove,
}: MoveVoicemailModalProps) => {
  const [selectedExtensionId, setSelectedExtensionId] = useState<number>()
  const [markAsUnread, setMarkAsUnread] = useState<boolean>(true)
  const { t } = useTranslation()
  const handleMove = () => {
    if (selectedExtensionId !== undefined) {
      onMove(selectedExtensionId, markAsUnread)
    }
  }
  const filteredVoicemailBoxes = voicemailBoxes.filter(
    (box) =>
      (box.voicemail_enabled === 1 ||
        box.type === 'ExtensionSharedVoicemailBox') &&
      box.id !== currentExtensionId,
  )

  return (
    <MangoModal
      isOpen={isOpen}
      onClose={onClose}
      size={Size.md}
      header={t('voicemail.mangoModal.headerText')}
      footer={
        <>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={onClose}
          >
            {t('voicemail.mangoModal.cancelButtonText')}
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleMove}
            ml="0.25rem"
            disabled={selectedExtensionId === undefined}
          >
            {t('voicemail.mangoModal.moveButtonText')}
          </MangoButton>
        </>
      }
    >
      <VStack gap={8} align="stretch" padding="1rem">
        <DropdownSelect
          placeholder={t('voicemail.mangoModal.selectVoicemailBoxText')}
          items={filteredVoicemailBoxes.map((box) => ({
            value: box.id,
            content: box.name,
          }))}
          selectedValue={selectedExtensionId}
          onSelect={(selectedId) =>
            setSelectedExtensionId(selectedId as number)
          }
        />
        <Text>{t('voicemail.mangoModal.destinationBoxWarning')}</Text>
        <Flex justifyContent="flex-start" mt="0.25rem">
          <Checkbox
            defaultChecked={markAsUnread}
            onCheckedChange={(e) => setMarkAsUnread(e.checked === true)}
          >
            {t('voicemail.mangoModal.markAsUnreadText')}
          </Checkbox>
        </Flex>
      </VStack>
    </MangoModal>
  )
}
